import React, { useState, useEffect } from "react";
import ChatMessageKit from "../../../data/ChatMessageKit";
import { ChatMessageEnums } from "../../../data/ChatMessageKit";

export function useCorporateChat({ urlParams, me, corporateOrganization }) {
  const AVAILABILITY_REFRESH_INTERVAL = 5; //seconds
  const [corporateChatExists, setCorporateChatExists] = useState(false);
  const [corporateChatList, setCorporateChatList] = useState(null);

  async function createCorporateChat() {
    // const { online, message, offlineMessage } =
    //   await getWelcomeMessageSettings();
    const data = await getWelcomeMessageSettings();

    let initialMessage = false;
    if (data?.offlineMessage) initialMessage = data?.offlineMessage;
    if (data?.message && data?.online) initialMessage = data?.message;

    const payload = {
      ...urlParams,
      corporateOrganization,
      eventUserId: me?.id,
    };

    if (initialMessage) payload.initialMessage = initialMessage;

    ChatMessageKit.createCorporateChatroom({
      ...urlParams,
      corporateOrganization,
      eventUserId: me?.id,
      initialMessage,
    }).then(() => {
      setCorporateChatExists(true);
    });
  }

  async function getWelcomeMessageSettings() {
    return new Promise((resolve) => {
      ChatMessageKit.getInitialCorporateMessageSettings({
        ...urlParams,
        onValue: (snapshot) => {
          resolve(snapshot.val());
        },
      });
    });
  }

  function setIsBusy() {
    const isBusy = me.availability === 2;

    ChatMessageKit.setCorporateClientIsBusy({
      ...urlParams,
      eventUserId: me?.id,
      isBusy,
    });
  }

  useEffect(() => {
    if (corporateOrganization && urlParams) {
      ChatMessageKit.corporateChatExists({
        ...urlParams,
        eventUserId: me?.id,
      }).then((exists) => {
        setCorporateChatExists(exists);

        if (!exists) createCorporateChat();
      });
    }
  }, [corporateOrganization, urlParams]);

  useEffect(() => {
    if (urlParams) {
      ChatMessageKit.corporateChatExists({
        ...urlParams,
        eventUserId: me?.id,
      }).then(setCorporateChatExists);
    }
  }, [urlParams]);

  useEffect(() => {
    if (corporateChatExists) setIsBusy();
  }, [me, corporateChatExists]);

  useEffect(() => {
    if (corporateChatExists) {
      const interval = setInterval(() => {
        ChatMessageKit.setCorporateClientAvailability({
          ...urlParams,
          eventUserId: me?.id,
          availability: Date.now(),
        });
      }, AVAILABILITY_REFRESH_INTERVAL * 1000);

      return () => {
        clearInterval(interval);
        ChatMessageKit.setCorporateClientAvailability({
          ...urlParams,
          eventUserId: me?.id,
          availability: 0,
        });
      };
    }
  }, [corporateChatExists]);

  useEffect(() => {
    if (urlParams && me && corporateOrganization && corporateChatExists) {
      setCorporateChatList({
        corporate: {
          props: {
            me,
            urlParams: {
              ...urlParams,
              eventUserId: me?.id,
            },
            key: `corporate-chat`,
            type: "corporate",
            unreadMessagesFilterFunction: (message) =>
              message.kind !== ChatMessageEnums.ANNONCEMENT,
          },
        },
      });
    }
  }, [urlParams, me, corporateOrganization, corporateChatExists]);

  return {
    corporateChatList,
  };
}
